import React, {useState} from "react";
import WorldBankTable from "./WorldBankTable/WorldBankTable";
import Collapse from "@material-ui/core/Collapse";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import {getCardIcon} from "../../../utils/utils"

function WorldBankCard(props) {

    const [expanded, setExpanded]   = useState(false);
    const [firstTime, setFirstTime] = useState(true);

    const {worldBank}    = props
    let initialExpand    = worldBank.flag === "positive"? false : true

    if (initialExpand !== expanded && firstTime===true){
        setExpanded(initialExpand);
    }

    const handleExpand = (event) => {
        event.stopPropagation();
        setFirstTime(false)
        setExpanded(!expanded);
    };

    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
                <div 
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px"}}
                >
                    Banco Mundial
                </div>
                <div style={{margin:"auto 10px"}}>
                    {getCardIcon(worldBank.flag)}
                </div>
                {worldBank.data.length === 0 ? null :
                <IconButton style={{marginLeft: "auto"}} onClick={handleExpand}>
                    {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>             
                }                    
            </div>
            {worldBank.data.length === 0 ? null :
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <div 
                    className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
                >
                    <WorldBankTable worldBank_data={worldBank.data}/>
                </div>
            </Collapse> 
            }     
        </div>
    );
}

export default WorldBankCard